import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-branch-icon',
  imports: [],
  templateUrl: './branch-icon.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './branch-icon.scss',
})
export class BranchIcon {}
